<template>
  <div class="newsApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='4'></headComponent>
    <div class="h"></div>
    <div class="proBg"  :style="'background: url('+newbg+') no-repeat center;'">
      <div class="txt">
        <h2 class="tit">新闻中心</h2>
        <div class="desc"><p>权威发布企业前沿资讯、产品动态与标杆案例，精准触达核心价值</p></div>
      </div>
    </div>
    <div style="height:15px"></div>
    <div class="main">
      <dl>
        <dd v-for="(item,i) in setNews">
          <a href="javascript:;" @click="$router.push('newsdetail?id='+item.id)">
            <div class="pic">
              <img :src="baseUrl+item.image" alt="">
            </div>
            <div class="tit">
              <div class="tips">{{item.title}}</div>
              <p>{{item.content.replace(/<[^>]+>/gim,"")}}</p>
              <h3>{{item.createtime}}</h3>
            </div>
            <span class="btn">了解更多  &gt;</span>
          </a>
        </dd>
        
      </dl>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        newbg:require('../../../assets/images/newsbg.jpg'),
        setNews:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getNews();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getNews:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/news',
          dataType:'json',
          success:function(data){
            that.setNews = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .newsApp .el-message-box{
    width:30%
  }
  .newsApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .newsApp .h{
    height:96px
  }
  .newsApp .proBg{
    height: 26.06vw;
    color:#fff;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .newsApp .proBg .txt{
    position: absolute;
    top: 50%;
    color: #fff;
    transform: translateY(-50%);
    left: 8.333vw;
  }
  .newsApp .proBg .txt .tit{
    font-size: 3vw;
    margin-bottom:20px;
    font-weight: normal;
  }
  .newsApp .proBg .txt .desc {
    font-size: 16px;
  }

  .newsApp .main{
    margin:0 auto;
    max-width:1600px;
  }
  .newsApp .main dl dt{
    font-size:20px;
    font-weight:bold;
    padding:25px 0 12px 0
  }
  .newsApp .main dl dd{
    float:left;
    width:25%;
    margin-bottom:12px;
  }
  .newsApp .main dl:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .newsApp .main dl dd a{
    display: block;
    background-color: #fff;
    margin: 0 12px 0 0;
    padding-bottom:25px;
  }
  .newsApp .main dl dd a .tit{
    margin-bottom:20px;
    padding: 0 10px;
  }
  .newsApp .main dl dd a .tit .tips{
    color: #333;
    font-size:17px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin:10px 0;
  }
  .newsApp .main dl dd a .tit h3{
    color: #666;
    font-size: 15px;
    padding:10px 0;
    font-weight:normal
  }
  .newsApp .main dl dd a .tit p{
    line-height: 1.81;
    color: #888;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    font-size: 15px;
  }
  .newsApp .main dl dd a .pic img{
    width:100%;
    display:block;
    margin:0 auto;
    height:220px;
    object-fit: cover;
  }
  .newsApp .main dl dd a  .btn{
    border: 1px solid rgba(51,51,51,.2);
    color: #777;
    display: block;
    width:60%;
    margin:0 auto;
    height:35px;
    text-align:center;
    line-height:35px;
    font-size:15px;
  }
  .newsApp .main dl dd a:hover .btn{
    border-color: #4470AF;
    background-color: #4470AF;
    color: #fff;
  }

  
  @media only screen and (max-width: 1199px) {
    .newsApp .header,.newsApp .h{
      height:60px;
    }
    .newsApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .newsApp .header .nav{
      text-align:right
    }
    .newsApp .header .nav li{
      margin:0 1.8vw
    }
    .newsApp .header .nav .close{
      display:none
    }
    .newsApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .newsApp .proBg{
      font-size:18px;
    }
    .newsApp .main dl dd{
      width:50%
    }
  } 
</style>